export enum CatalogPhotoThumbnail {
  Thumb24 = 'thumb24',
  Thumb48 = 'thumb48',
  Thumb70 = 'thumb70',
  Thumb150 = 'thumb150',
}
